import React, { useEffect, useState } from "react";

const Timer = (props) => {
  const [isActive, setIsActive] = useState(false);
  const [counter, setCounter] = useState(props?.limit);

  const startTimer = () => {
    setIsActive(true);
    setCounter(props.time);
    const interval = setInterval(() => {
      setCounter((prevCounter) => prevCounter - 1);
    }, 1000);

    setTimeout(() => {
      clearInterval(interval);
      setIsActive(false);
      props.isTime(0);
    }, counter * 1000);
  };

  //   const stopTimer = () => {
  //     setIsActive(false);
  //     setCounter(30);
  //   };
  useEffect(() => {
    let numberString = counter?.toString();
    const length = numberString?.length;
    if (length === 1) {
      numberString = numberString.toString().padStart(2, "0");
    }
    setCounter(numberString);
    console.log("length", length);
  }, [counter]);
  useEffect(() => {
    startTimer();
  }, []);
  return (
    <div>
      {counter}
      {/* <button onClick={isActive ? stopTimer : startTimer}>
        {isActive ? 'Stop Timer' : 'Start Timer'}
      </button> */}
    </div>
  );
};

export default Timer;
